import React from 'react'

import {Grid} from '../../grid'
import {makeStyles, SystemColors, Theme} from '../../theme'

const useClasses = makeStyles(
  (theme: Theme) => ({
    root: {
      color: theme.palette.text.secondary,
      fontWeight: 500,
      fontSize: theme.typography.pxToRem(13),
      lineHeight: theme.typography.pxToRem(15),
      padding: theme.spacing(0.5, 1),
      background: theme.go.schemes.colors.system[SystemColors.BgMinor],
      borderRadius: theme.spacing(0.75),
    },
  }),
  {name: 'SectionDivider'},
)

const SectionDivider: React.FC<React.PropsWithChildren<unknown>> = props => {
  const classes = useClasses()

  return <Grid {...props} classes={classes} />
}

export default SectionDivider
